import {
    CREATE_FIXED_ASSET,
    GET_FIXED_ASSETS,
    GET_FIXED_ASSET_DETAILS,
    UPDATE_FIXED_ASSET,
    DELETE_FIXED_ASSET,
    GET_DEPRECIATION_METHODS,
    GET_FIXED_ASSET_CATEGORIES,
    CLEAR_FIXED_ASSET_STATE,
} from '../../index.types';

export function createFixedAsset(data) {
    return {
        type: CREATE_FIXED_ASSET,
        data
    }
}

export function getFixedAssets(data) {
    return {
        type: GET_FIXED_ASSETS,
        data
    }
}

export function getFixedAssetDetails(data) {
    return {
        type: GET_FIXED_ASSET_DETAILS,
        data
    }
}

export function updateFixedAsset(data) {
    return {
        type: UPDATE_FIXED_ASSET,
        data
    }
}

export function deleteFixedAsset(data) {
    return {
        type: DELETE_FIXED_ASSET,
        data
    }
}

export function getDepreciationMethods() {
    return {
        type: GET_DEPRECIATION_METHODS
    }
}

export function getFixedAssetCategories(data) {
    return {
        type: GET_FIXED_ASSET_CATEGORIES,
        data
    }
}

export function clearFixedAssetState() {
    return {
        type: CLEAR_FIXED_ASSET_STATE
    }
}
